module.exports = __webpack_public_path__ + "static/img/banner-AI设备专家平台.e1692d9e.webp";